export default __webpack_public_path__ + "static/bg-alternative-blue-7bf84d52e65c3d2e0228e7928ef739f2.jpg";